<div class="xp-column-list" cdkDropList (cdkDropListDropped)="drop($event)">
	<div class="xp-column-list__item"
	     *ngFor="let column of columns(); trackBy: trackByField"
	     cdkDrag>
		<span class="xp-column-list__label">{{ column.header }}</span>
		<div class="xp-column-list__actions">
			<mat-checkbox [checked]="column.active" (change)="setActive(column, $event.checked)"></mat-checkbox>
			<mat-icon class="xp-column-list__handle" cdkDragHandle>drag_indicator</mat-icon>
		</div>
	</div>
</div>
